import { ContentBox } from "@msuite/ui/app-shell";
import { DataTable } from "@msuite/ui/table";
import { useIncomingInvoicePaymentRuns } from "@/hooks/use-incoming-invoice-payment-runs";
import { columns } from "./table-config";

/** Every payment file the organisation exported, newest first, each with the invoices it paid. */
export function IncomingInvoicePaymentRuns() {
	/** Query */
	const { paymentRuns, isLoading, queryKey, refetch } = useIncomingInvoicePaymentRuns();

	/** Render */
	return (
		<ContentBox>
			<DataTable
				data={paymentRuns}
				columns={columns}
				isLoading={isLoading}
				queryKey={queryKey}
				refetch={refetch}
				menu={null}
				persistenceKey="incoming-invoice-payment-runs-table"
			/>
		</ContentBox>
	);
}
